<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "ticket_rubrics",
    cardSetLink: "ticket_rubrics",
    item: null,
    fields: [
      {
        col: "col-12",
        label: "Название",
        key: "name",
        labelKey: "name",
        type: "field",
      },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
